import { TranslationKey } from '@libs/focus-frontend-i18n/src';

import { playVideo } from './actions';

interface VideoIdToConfigEntry {
  langToWistiaId: { [x: string]: string };
  titleTranslation: TranslationKey;
}

interface VideoIdToConfig {
  [x: string]: VideoIdToConfigEntry;
}

const videoIdToConfig: VideoIdToConfig = {
  introToDeals: {
    titleTranslation: 'help.introToDeals',
    langToWistiaId: {
      nl: 'mkoo1mk90m',
      'nl-NL': 'mkoo1mk90m',
      fr: '72920vhdbo',
      'fr-FR': '72920vhdbo',
    },
  },
  introToProjects: {
    titleTranslation: 'help.introToProjects',
    langToWistiaId: {
      nl: '18i1j1eee3',
      'nl-NL': '18i1j1eee3',
      fr: 'tvwcwi7t5b',
      'fr-FR': 'tvwcwi7t5b',
    },
  },
  introToCRM: {
    titleTranslation: 'help.introToCRM',
    langToWistiaId: {
      en: 'aps58dbtl7',
      nl: 'oodhdoj31a',
      'nl-NL': 'oodhdoj31a',
      fr: '11tcavviec',
      'fr-FR': '11tcavviec',
    },
  },
  introToInvoices: {
    titleTranslation: 'help.introToInvoices',
    langToWistiaId: {
      fr: 'g0rp7enj2q',
      'fr-FR': 'g0rp7enj2q',
    },
  },
  introToCustomerMeeting: {
    titleTranslation: 'help.introToCustomerMeeting',
    langToWistiaId: {
      en: '7aa2qrp3sl',
      nl: 'usublrtibs',
      'nl-NL': 'il7xcgintk',
      fr: 'xp6sbjdw26',
      'fr-FR': 'jcszdjljqt',
      es: 'rmjqatxpa9',
      it: '2m2ohzrh0d',
      de: '36ivucpdi7',
    },
  },
  introToInsights: {
    titleTranslation: 'insights.help.title',
    langToWistiaId: {
      en: 'mqg4dkiu3m',
      nl: 'k0esoqnn04',
      'nl-Nl': 'k0esoqnn04',
    },
  },
};

export const hasVideoAvailable = (videoId: string) => {
  const language = window.top!.TLGLOBALS.LANGUAGE;
  return (videoIdToConfig[videoId] && videoIdToConfig[videoId]['langToWistiaId']![language]) !== undefined;
};

export const play = (videoId: string, fallbackLanguage?: string) => {
  const { titleTranslation, langToWistiaId } = videoIdToConfig[videoId];
  const language = window.top!.TLGLOBALS.LANGUAGE;

  let videoIdForLanguage = langToWistiaId[language];
  if (!videoIdForLanguage && fallbackLanguage) {
    videoIdForLanguage = langToWistiaId[fallbackLanguage];
  }

  if (titleTranslation && langToWistiaId && videoId) {
    window.top!.store.dispatch(
      playVideo({
        url: `https://fast.wistia.net/embed/iframe/${videoIdForLanguage}?controlsVisibleOnLoad=false&playButton=true`,
        titleTranslation,
      }),
    );
  }
};
